import {
  Box,
  CircularProgress as MUICircularProgress,
} from "@/common/styles/style";
import { style } from "./style";

export default function CircularProgress() {
  return (
    <Box sx={style}>
      <MUICircularProgress />
    </Box>
  );
}
